/**
 * @description 服务监控 serverMonitor
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const serverMonitorBiz = new Logic()

serverMonitorBiz.serverMonitor = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.serverMonitor.serverMonitor,
    data: data
  })
}

serverMonitorBiz.getAppList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.serverMonitor.getAppList,
    data: data
  })
}

serverMonitorBiz.getAppInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.serverMonitor.getAppInfo,
    data: data
  })
}

serverMonitorBiz.getChartConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.serverMonitor.getChartConfig,
    data: data
  })
}

serverMonitorBiz.getChartThreshold = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.serverMonitor.getChartThreshold,
    data: data
  })
}

serverMonitorBiz.getIpList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getIP,
    data: data
  })
}

export default serverMonitorBiz
